import { render, staticRenderFns } from "./BlogPage.vue?vue&type=template&id=4dce228c&scoped=true&"
import script from "./BlogPage.vue?vue&type=script&lang=js&"
export * from "./BlogPage.vue?vue&type=script&lang=js&"
import style0 from "./BlogPage.vue?vue&type=style&index=0&id=4dce228c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dce228c",
  null
  
)

export default component.exports